<template>
  <div class="subtitle-1">
    <!-- <i class="iconfont icon-biaoti" :style="`color:#1e74ff`"></i> -->
    <svg
      class="icon_font"
      aria-hidden="true"
      :style="`width:${width};height:${height};`"
    >
      <use :xlink:href="`#icon-${iconLeft}`"></use>
    </svg>
    <div class="title" :style="`color:${textColor};font-size:${fontSize}`">
      {{ title }}
    </div>
    <svg
      class="icon_font"
      aria-hidden="true"
      :style="`width:${width};height:${height}`"
    >
      <use :xlink:href="`#icon-${iconRight}`"></use>
    </svg>
  </div>
</template>
<script>
export default {
  props: {
    //图标宽
    width: {
      type: String,
      default: "26px",
    },
    //图标高
    height: {
      type: String,
      default: "26px",
    },
    //标题颜色
    textColor: {
      type: String,
      default: "#7ec699",
    },
    //标题大小
    fontSize: {
      type: String,
      default: "12px",
    },
    //标题
    title: {
      type: String,
      default: "标题",
    },
    //左icon
    iconLeft: {
      type: String,
      default: "biaoti",
    },
    //右icon
    iconRight: {
      type: String,
      default: "",
    },
  },
};
</script>
<style lang="scss" scoped>
.subtitle-1 {
  display: flex;
  align-items: center;
  .title {
    margin: 0 4px;
    font-weight: 700;
  }
}
</style>